const assessmentColumnHeaders = {
  YEAR: 'Year',
  C6_ID: 'C6 ID',
  CUSTOMER_ID: 'Customer ID',
  CUSTOMER_NAME: 'Customer Name',
  C6_NAME: 'C6 Name',
  TIER: 'Tier',
  CHANNEL: 'Channel',
  SCORE: 'Score',
  YEAR_OVER_YEAR: 'YoY %',
  LAST_YEAR_SCORE: 'Last Year Score',
  STATUS: 'Status',
  PENDING_USER: 'Pending User',
  NEXT_ACTION_BY: 'Next Action By',
  BUSINESS_UNIT: 'Business Unit',
};

const assessmentColumnHeaderAccessors = {
  [assessmentColumnHeaders.YEAR]: 'year',
  [assessmentColumnHeaders.C6_ID]: 'c6Id',
  [assessmentColumnHeaders.CUSTOMER_ID]: 'customerId',
  [assessmentColumnHeaders.CUSTOMER_NAME]: 'customerName',
  [assessmentColumnHeaders.C6_NAME]: 'c6Name',
  [assessmentColumnHeaders.BUSINESS_UNIT]: 'businessUnit',
  [assessmentColumnHeaders.TIER]: 'tier',
  [assessmentColumnHeaders.CHANNEL]: 'channel',
  [assessmentColumnHeaders.SCORE]: 'score',
  [assessmentColumnHeaders.LAST_YEAR_SCORE]: 'lastYearScore',
  [assessmentColumnHeaders.STATUS]: 'status',
  [assessmentColumnHeaders.PENDING_USER]: 'pendingUser',
  [assessmentColumnHeaders.NEXT_ACTION_BY]: 'pendingUser',
};

export { assessmentColumnHeaders, assessmentColumnHeaderAccessors };
